import { useFormatting, useTranslation } from '../../../i18n/i18n';
import { useCart } from '../../../state/cart';
import { UiContainer } from '../../../state/ui';
import { Button } from '../../Form/Button';
import { Icon, shopping_cart } from '../../Icon/Icon';
import './CartButton.css';

export const CartButton = (): JSX.Element => {
	const ui = UiContainer.useContainer();
	const t = useTranslation().cart;
	const { cart } = useCart();
	const { asPrice } = useFormatting();
	const count = cart.items?.length ?? 0;
	const totals = cart.totals;

	if (!totals) return <Button className="cart-button" />;
	const { subTotal, subTotalVat } = totals;

	const itemsInCartTag = (
		<>
			<span className="article-count">{count}</span>{' '}
			<span className="not-mobile">{asPrice(subTotal + (ui.priceWithVat ? subTotalVat : 0))}</span>
		</>
	);

	return (
		<Button className="cart-button" onClick={ui.toggleCart}>
			<Icon shape={shopping_cart} size={20} />
			<span className="items-in-cart-text">{count > 0 ? itemsInCartTag : t.empty}</span>
		</Button>
	);
};
